export const TITLE = `למי מיועדת המשכנתא המשלימה של WeCheck?`

export const PARAGRAPH = `המשכנתא המשלימה מיועדת הן לרכישת נכס חדש והן לבעלי נכס קיים, אשר מעוניינים לקבל שיעורי מימון גבוהים יותר מאשר אלה הניתנים על ידי הבנקים ועד לגובה של 85%. יש מגוון שימושים למשכנתא המשלימה, נציין את העיקריים שבהם:`

export const CTA_TITLE = `למה אתם מחכים?`